const appStyle = require('../app.style').default;

const modalStyle = {
    width: (appStyle.applicationStyle.width * 0.95)
}

const informationStyle = {
    width: appStyle.applicationStyle.width,
    marginBottom: 5
}

const boardStyle = {
    width: appStyle.applicationStyle.width,
    height: appStyle.applicationStyle.width,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5
}

const panelStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
}

const selectorStyle = {
    width: appStyle.applicationStyle.width,
    height: (appStyle.applicationStyle.width / 4)
}

const panelSize = (appStyle.applicationStyle.width * 0.125)
const selectorSlotSize = (appStyle.applicationStyle.width * 0.19)

const loadImage = {
    position: 'absolute',
    width: 0,
    height: 0
}

export default {
    modalStyle,
    boardStyle,
    informationStyle,
    panelStyle,
    selectorStyle,
    selectorSlotSize,
    panelSize,
    loadImage
}